// extracted by mini-css-extract-plugin
export default {"card":"Card_card__+7a1N"};